"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountWrappedField = exports.CategoryWrappedField = exports.WrappedField = exports.ButtonArea = exports.TitleHeader = void 0;
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const QButton_1 = __importDefault(require("components/QButton"));
const CategoryField_1 = __importDefault(require("components/QuickenControls/CategoryField"));
const QAmountField_1 = __importDefault(require("components/QAmountField"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const TitleHeader = ({ classes }) => (<div className={classes.header}>
    <Typography_1.default variant="h5" className={classes.title}>
      Add Budget Category
    </Typography_1.default>
    <Typography_1.default variant="body1">
      Select a category to add to your budget.  An average amount from your previous transactions
      will be entered on your behalf.  You may choose to update the amount.
    </Typography_1.default>
  </div>);
exports.TitleHeader = TitleHeader;
const ButtonArea = ({ onAdd, onClose, disableSubmit }) => (<DialogActions_1.default>
    <QButton_1.default onClick={onClose} id="add-budget-cancel-button">
      Cancel
    </QButton_1.default>
    <QButton_1.default disabled={disableSubmit} onClick={onAdd} id="add-to-budget-button">
      Add To Budget
    </QButton_1.default>
  </DialogActions_1.default>);
exports.ButtonArea = ButtonArea;
const WrappedField = (_a) => {
    var { children, caption } = _a, other = __rest(_a, ["children", "caption"]);
    const { classes } = useStyles();
    return (<div {...other}>
      <Typography_1.default variant="caption">
        {caption}
      </Typography_1.default>
      <div className={classes.fieldWrapper}>
        {children}
      </div>
    </div>);
};
exports.WrappedField = WrappedField;
const CategoryWrappedField = (_a) => {
    var { catFieldProps } = _a, other = __rest(_a, ["catFieldProps"]);
    return (<exports.WrappedField caption="Select a Category" style={{ flex: 1, marginRight: 40 }} {...other}>
    <CategoryField_1.default name="budget-add-cat-field-category" id="budget-add-cat-field-category" fontSize="22px" editable allowBlank createEnabled disableUnderline initialFocus {...catFieldProps}/>
  </exports.WrappedField>);
};
exports.CategoryWrappedField = CategoryWrappedField;
const AmountWrappedField = (_a) => {
    var { currentAmount, onBlur, classes, onSubmit, currency } = _a, other = __rest(_a, ["currentAmount", "onBlur", "classes", "onSubmit", "currency"]);
    return (<exports.WrappedField caption="Amount" style={{ flex: 0, minWidth: 150 }} {...other}>
    <QAmountField_1.default name="budgetAddAmountField" id="budget-category-amount-field" editable value={currentAmount} currency={currency} classes={classes} onSubmit={onSubmit} onBlur={onBlur} disableUnderline decimals={0}/>
  </exports.WrappedField>);
};
exports.AmountWrappedField = AmountWrappedField;
